import React from "react";
import styled from "styled-components";

import { currentLanguage } from "helpers";
import WP from "WP";

import Image from "partials/Image";
import Button from "partials/Button";
import GridElement from "partials/GridElement";

import Media from "css/Media";

const ProductCard = (props) => {
  const getDayPrice = (price) => {
    if (currentLanguage() === "no") {
      if (props.isMobile) {
        return `NOK ${price.toLocaleString("fr")} per dag.`.toUpperCase();
      } else {
        return `NOK ${price.toLocaleString("fr")} per dag.`;
      }
    } else {
      if (props.isMobile) {
        return `NOK ${price.toLocaleString("fr")} per day.`.toUpperCase();
      } else {
        return `NOK ${price.toLocaleString("fr")} per day.`;
      }
    }
  };

  const getWeekPrice = (price) => {
    if (currentLanguage() === "no") {
      if (props.isMobile) {
        return `NOK ${price.toLocaleString("fr")} per uke.`.toUpperCase();
      } else {
        return `NOK ${price.toLocaleString("fr")} per uke.`;
      }
    } else {
      if (props.isMobile) {
        return `NOK ${price.toLocaleString("fr")} per week.`.toUpperCase();
      } else {
        return `NOK ${price.toLocaleString("fr")} per week.`;
      }
    }
  };

  /* const getInsuranceCost = (insurance) => {
    if (currentLanguage() === "no") {
      return `NOK ${insurance[0].price.toLocaleString(
        "fr"
      )} per dag. Maks egenandel NOK ${insurance[0].deductible.toLocaleString(
        "fr"
      )}.`;
    } else
      return `NOK ${insurance[0].price.toLocaleString(
        "fr"
      )} per day. Maximum deductible NOK ${insurance[0].deductible.toLocaleString(
        "fr"
      )}.`;
  }; */

  const handleReservation = () => {
    props.handleClick(product);
  };

  const { product, isMobile, disabled } = props;

  if (product) {
    return (
      <WrapperGrid>
        <GridElement
          colStart={{ default: 1, s: 1 }}
          colEnd={{ default: 8, s: 10 }}
          rowStart={1}
        >
          <ImageGrid>
            <GridElement
              colStart={{ default: 1, s: 1 }}
              colEnd={{ default: 8, s: 10 }}
              rowStart={1}
            >
              <Image image={product.acf.image} background ratio='5:4' />
            </GridElement>
            <GridElement
              colStart={{ default: 1, s: 1 }}
              colEnd={{ default: 8, s: 10 }}
              rowStart={2}
            >
              {isMobile && product.acf.bulletpoints && (
                <BulletPoints>
                  {product.acf.bulletpoints.map((item, idx) => {
                    return (
                      <BulletPoint key={idx}>
                        {item.bullet_point.toUpperCase()} •
                      </BulletPoint>
                    );
                  })}
                </BulletPoints>
              )}
              {!isMobile && product.acf.bulletpoints && (
                <BulletPoints>
                  {product.acf.bulletpoints.map((item, idx) => {
                    return (
                      <BulletPoint key={idx}>{item.bullet_point}</BulletPoint>
                    );
                  })}
                </BulletPoints>
              )}
            </GridElement>
          </ImageGrid>
        </GridElement>
        <GridElement
          colStart={{ default: 1, s: 10 }}
          colEnd={{ default: 8, s: 20 }}
          rowStart={{ default: 3, s: 1 }}
        >
          <ContentGrid>
            <GridElement
              colStart={{ default: 1, s: 4 }}
              colEnd={{ default: 8, s: 11 }}
              rowStart={1}
            >
              <Title>{product.acf.title}</Title>
            </GridElement>
            <GridElement
              colStart={{ default: 1, s: 4 }}
              colEnd={{ default: 8, s: 11 }}
              rowStart={2}
            >
              <ProductDescription>{product.acf.description}</ProductDescription>
            </GridElement>
            <GridElement
              colStart={{ default: 1, s: 4 }}
              colEnd={{ default: 8, s: 11 }}
              rowStart={3}
            >
              {product.acf.day_rate ? (
                <PricePoint>
                  <span>{WP.trans.pricePerDay}</span>
                  <span>{getDayPrice(product.acf.day_rate)}</span>
                </PricePoint>
              ) : null}
              {product.acf.day_rate_following ? (
                <PricePoint>
                  <span>{WP.trans.followingDay}</span>
                  <span>{getDayPrice(product.acf.day_rate_following)}</span>
                </PricePoint>
              ) : null}
              {product.acf.price_weekdays ? (
                <PricePoint>
                  <span>{WP.trans.weekdays}</span>
                  <span>{getDayPrice(product.acf.price_weekdays)}</span>
                </PricePoint>
              ) : null}
              {product.acf.following_day_weekdays_price ? (
                <PricePoint>
                  <span>{WP.trans.followingDay}</span>
                  <span>
                    {getDayPrice(product.acf.following_day_weekdays_price)}
                  </span>
                </PricePoint>
              ) : null}
              {product.acf.price_weekends ? (
                <PricePoint>
                  <span>{WP.trans.weekend}</span>
                  <span>{getDayPrice(product.acf.price_weekends)}</span>
                </PricePoint>
              ) : null}
              {product.acf.following_day_weekends_price ? (
                <PricePoint>
                  <span>{WP.trans.followingDay}</span>
                  <span>
                    {getDayPrice(product.acf.following_day_weekends_price)}
                  </span>
                </PricePoint>
              ) : null}
              {product.acf.price_week ? (
                <PricePoint>
                  <span>{WP.trans.week}</span>
                  <span>{getWeekPrice(product.acf.price_week)}</span>
                </PricePoint>
              ) : null}
            </GridElement>
            {/* product.acf.product_insurance ? (
              <GridElement
                colStart={{ default: 1, s: 4 }}
                colEnd={{ default: 8, s: 11 }}
                rowStart={4}
              >
                <InsuranceCost>
                  <span>{WP.trans.insurance}</span>
                  <span>{getInsuranceCost(product.acf.product_insurance)}</span>
                </InsuranceCost>
              </GridElement>
            ) : null */}
            <GridElement
              colStart={{ default: 1, s: 4 }}
              colEnd={{ default: 8, s: 11 }}
              rowStart={4}
              justify='start'
            >
              <StyledButton
                onClick={disabled ? null : handleReservation}
                disabled={disabled}
              >
                {product.acf.rental_type === "snowmobile"
                  ? WP.trans.sendRequest
                  : WP.trans.reserveBlank + product.acf.title.toLowerCase()}
              </StyledButton>
            </GridElement>
          </ContentGrid>
        </GridElement>
      </WrapperGrid>
    );
  } else return null;
};

export default ProductCard;

const WrapperGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr 0.359fr) 1fr;
  grid-template-rows: ${(props) => props.rows || "auto"};
  margin-bottom: ${(props) => props.theme.spacing.blockS};

  ${Media.greaterThan("xs")`
        grid-template-columns: repeat(3, 1fr .13fr) 1fr;
    `}

  ${Media.greaterThan("s")`
        grid-template-columns: repeat(9, 1fr .67fr) 1fr;
        margin-bottom: ${(props) => props.theme.spacing.blockS};
    `}

    ${Media.greaterThan("m")`
        grid-template-columns: repeat(9, 1fr .435fr) 1fr;
    `}

    ${Media.greaterThan("l")`
        grid-template-columns: repeat(9, 1fr .322fr) 1fr;
    `}
`;

const BulletPoints = styled.ul`
  padding: ${(props) => props.theme.spacing.contentM} 0
    ${(props) => props.theme.spacing.contentXL};
  display: flex;
  flex-wrap: wrap;

  ${Media.greaterThan("s")`
        background: #EBEBEB;
        padding: ${(props) => props.theme.spacing.contentXL} ${(props) =>
    props.theme.spacing.elementS};
        display: block;
        columns: 2 auto;
    `}
`;

const BulletPoint = styled.li`
  list-style: none;
  margin-right: 5px;
  font-size: 11px;
  line-height: 20px;

  ${Media.greaterThan("s")`
        list-style: disc;
        margin-right: 0;
        font-size: 16px;
        line-height: 25px;
    `}
`;

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr 0.359fr) 1fr;
  grid-template-rows: ${(props) => props.rows || "auto"};

  ${Media.greaterThan("xs")`
        grid-template-columns: repeat(3, 1fr .13fr) 1fr;
    `}

  ${Media.greaterThan("s")`
        grid-template-columns: repeat(4, 1fr .67fr) 1fr;
    `}

    ${Media.greaterThan("m")`
        grid-template-columns: repeat(4, 1fr .435fr) 1fr;
    `}

    ${Media.greaterThan("l")`
        grid-template-columns: repeat(4, 1fr .322fr) 1fr;
    `}
`;

const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr 0.359fr) 1fr;
  grid-template-rows: ${(props) => props.rows || "auto"};

  ${Media.greaterThan("xs")`
        grid-template-columns: repeat(3, 1fr .13fr) 1fr;
    `}

  ${Media.greaterThan("s")`
        grid-template-columns: repeat(5, .67fr 1fr) 1fr;
        padding: ${(props) => props.theme.spacing.elementM} 0 0;
    `}

    ${Media.greaterThan("m")`
        grid-template-columns: repeat(5, .435fr 1fr) 1fr;
    `}

    ${Media.greaterThan("l")`
        grid-template-columns: repeat(5, .322fr 1fr) 1fr;
    `}
`;

const Title = styled.span`
  display: block;
  font-size: 22px;
  line-height: 27px;
  padding-bottom: ${(props) => props.theme.spacing.contentL};

  ${Media.greaterThan("s")`
        ${(props) => props.theme.fonts.h4};
        padding-bottom: ${(props) => props.theme.spacing.contentXL};
    `}
`;

const ProductDescription = styled.span`
  display: block;
  line-height: 25px;
  padding-bottom: ${(props) => props.theme.spacing.contentL};

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.contentXL};
    `}
`;

const PricePoint = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  line-height: 23px;

  &:last-of-type {
    padding-bottom: ${(props) => props.theme.spacing.contentM};
  }

  ${Media.greaterThan("s")`
        font-size: 16px;
        line-height: 25px;
        padding-bottom: ${(props) => props.theme.spacing.contentXS};

        &:last-of-type {
            padding-bottom: ${(props) => props.theme.spacing.elementS};
        }
    `}
`;

/* const InsuranceCost = styled.span`
  display: block;
  padding-bottom: ${(props) => props.theme.spacing.elementXS};

  span {
    display: block;
    line-height: 25px;
  }

  ${Media.greaterThan("s")`
        padding-bottom: ${(props) => props.theme.spacing.elementS};
    `}
`; */

const StyledButton = styled(Button)`
  padding: 25px 38px;
`;
